/**
 * Tenzen glass gate.
 *
 * This file used to generate a per-surface SVG displacement map and hang it
 * off `backdrop-filter: url(#filter)`, which really did bend the page pixels
 * behind each pill. Replaced on Aditya's call, and it is the right one: the
 * effect cost a canvas pass, a toDataURL and a filter graph per surface
 * shape, plus a ResizeObserver to rebuild them on every resize, and at
 * nav-pill size the bend was worth almost nothing next to a plain frost. It
 * is now an ordinary `backdrop-filter: blur() saturate()`, declared in CSS.
 *
 * All that is left here is the capability gate. Every glass rule in
 * `snippets/liquid-glass-init.liquid` and `snippets/tenzen-topnav.liquid` is
 * scoped to `html.tenzen-glass-on`, so a browser without backdrop-filter
 * keeps the opaque fallbacks instead of a transparent, unreadable pill.
 *
 * The displacement build is kept alongside this file as
 * `tenzen-glass.displacement.bak.js` if it is ever wanted back.
 */
(function () {
  'use strict';

  function start() {
    if (!window.CSS || typeof CSS.supports !== 'function') return;
    // Prefixed check included for older WebKit, which shipped the property
    // under -webkit- before unprefixing it.
    var ok = CSS.supports('backdrop-filter', 'blur(1px)') ||
             CSS.supports('-webkit-backdrop-filter', 'blur(1px)');
    if (!ok) return;
    document.documentElement.classList.add('tenzen-glass-on');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
